import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { AddNotesPopup } from "./add-notes";

@NgModule({
  declarations: [AddNotesPopup],
  imports: [
    IonicPageModule.forChild(AddNotesPopup),
    TranslateModule.forChild(),
  ],
})
export class AddNotesPopupPageModule {}



// WEBPACK FOOTER //
// ./src/pages/order-managment/add-notes/add-notes.module.ts